export const authenticationBaseUrl = "https://tokoss.pinnacle-of-success.com";
export const token = ""
export const apikey = ""

const backendUrls = {
  Authentication: {
    login: authenticationBaseUrl + "/api/login",
    verified: authenticationBaseUrl + "/api/users/verify",
    unVerified: authenticationBaseUrl + "/api/users/un-verify"
  },
  Users: {
    users: authenticationBaseUrl + "/api/users"
  },
  Drivers: {
    drivers: authenticationBaseUrl + "/api/drivers"
  },
  Bookings: {
    bookings: authenticationBaseUrl + "/api/bookings"
  },
  Timelines: {
    timelines: authenticationBaseUrl + "/api/timelines"
  },
  Messages: {
    messages: authenticationBaseUrl + "/api/messages",
    messages_users: authenticationBaseUrl + "/api/users-messages",
    add_message: authenticationBaseUrl + "/api/send-message-to-drivers",
    add_message_user: authenticationBaseUrl + "/api/send-message-to-users",
  },



  Others: {
    stats: authenticationBaseUrl + "/api/stats",
    courses: authenticationBaseUrl + "/api/op.course/search",
    students: authenticationBaseUrl + "/api/student-branch-company-search/all",
    student: authenticationBaseUrl + "/api/student-search",
    parents: authenticationBaseUrl + "/api/op.parent/search",
    fees: authenticationBaseUrl + "/api/op.fees.terms/search",
    courses: authenticationBaseUrl + "/api/op.course/search",
    batches: authenticationBaseUrl + "/api/op.batch/search",
    subjects: authenticationBaseUrl + "/api/op.subject/search",
    admissions: authenticationBaseUrl + "/api/op.admission.register/search",
    teachers: authenticationBaseUrl + "/api/teacher-branche-company-search/all",
    faculties: authenticationBaseUrl + "/api/op.faculty/search",
    allParent: authenticationBaseUrl + "/api/parent-branche-company-search/all",
    academyYear: authenticationBaseUrl + "/api/academy-year-search",
    academyTerm: authenticationBaseUrl + "/api/academy-term-search",
    companyYearByPartnerId: authenticationBaseUrl + "/api/company-search",
    academicYearAdd: authenticationBaseUrl + "/api/create/academic-year",
    academicYearEdit: authenticationBaseUrl + "/api/update/academic-year",
    academicTermAdd: authenticationBaseUrl + "/api/create/academic-term",
    academicTermEdit: authenticationBaseUrl + "/api/update/academic-term",
    feesCreate: authenticationBaseUrl + "/api/create/fees",
    feesUpdate: authenticationBaseUrl + "/api/update/fees",
    courseCreate: authenticationBaseUrl + "/api/create/course",
    courseUpdate: authenticationBaseUrl + "/api/update/course",
    batchCreate: authenticationBaseUrl + "/api/create/batch",
    batchUpdate: authenticationBaseUrl + "/api/update/batch",
    subjectCreate: authenticationBaseUrl + "/api/create/subject",
    subjectUpdate: authenticationBaseUrl + "/api/update/subject",
    academicYearSearch: authenticationBaseUrl + "/api/op.academic.year/search",
    academicTermSearch: authenticationBaseUrl + "/api/op.academic.term/search",
    sessionSearch: authenticationBaseUrl + "/api/op.session/search",
    courseFeesSearch: authenticationBaseUrl + "/api/courses-fees-search",
    timetableSearch: authenticationBaseUrl + "/api/get/sessions",
    admissionCreate: authenticationBaseUrl + "/api/create/admission-register",
    admissionUpdate: authenticationBaseUrl + "/api/update/admission-register",
    admissionCourse: authenticationBaseUrl + "/api/admission/student/courses",
    courseFeesCreate: authenticationBaseUrl + "/api/create/product",
    courseFeesUpdate: authenticationBaseUrl + "/api/update/product",
    sessionCreate: authenticationBaseUrl + "/api/create/admission-register",
    sessionUpdate: authenticationBaseUrl + "/api/update/admission-register",
    addTimetable: authenticationBaseUrl + "/api/create/time-table",
    getAttendanceStudent: authenticationBaseUrl + "/api/attendance-sheets/by-student",
    getExamCourse: authenticationBaseUrl + "/api/marksheet/by-student",
    addStudent: authenticationBaseUrl + "/api/create/student",
    studentsCompany: authenticationBaseUrl + "/api/student-company-search/all",
    updateParent: authenticationBaseUrl + "/api/update/parent",
    applicationAdmission: authenticationBaseUrl + "/api/admissions/by-register",
    oneAdmission: authenticationBaseUrl + "/api/op.admission.register",
    resPartnerTitle: authenticationBaseUrl + "/api/res.partner.title/search",
    opFeesTerm: authenticationBaseUrl + "/api/op.fees.terms/search",
    opBatch: authenticationBaseUrl + "/api/op.batch/search",
    opClassrooms: authenticationBaseUrl + "/api/op.classroom/search",
    opClassroomsDetails: authenticationBaseUrl + "/api/classroom",
    opAddClassrooms: authenticationBaseUrl + "/api/create/classroom",
    editClassroom: authenticationBaseUrl + "/api/update/classroom",
    admissionRegisterByCourse: authenticationBaseUrl + "/api/admission-register/by-course",
    createAdmissionAndAssignInClassroom: authenticationBaseUrl + "/api/create/admission-with-assignment"

  },

};
export default backendUrls;
